import { select } from '@js/util/select'

/**
 * @param {HTMLTextAreaElement} textarea
 */
function resizeInput(textarea) {
  textarea.style.height = 'auto'

  let padding = 4

  if (textarea.scrollHeight > textarea.clientHeight + padding) {
    textarea.style.height = `${textarea.scrollHeight + padding}px`
  }
}

select('.wpforms-field', el => {
  let input = el.querySelector('textarea, input')
  if (!input) return

  let toggle = () => {
    el.classList.toggle('wpforms-field-filled', input.value.length > 0)
  }

  toggle()
  input.addEventListener('blur', toggle)

  let resize = () => resizeInput(input)
  if (input.nodeName === 'TEXTAREA' && !CSS.supports('(field-sizing: content)')) {
    input.rows = 1
    resizeInput(input)
    input.style.resize = 'none'
    input.addEventListener('input', resize)
  }

  return () => {
    input?.removeEventListener('blur', toggle)
    input?.removeEventListener('input', resize)
  }
})
